import { ProcessPaymentType } from '../../forms/ProcessPayment/ProcessPaymentType';

export const PAYMENT_TYPES_MANUAL_PAYMENT = [
    ProcessPaymentType.GatewayPayment,
    ProcessPaymentType.MewsTerminalPayment,
    ProcessPaymentType.ExternalCardPayment,
    ProcessPaymentType.CashPayment,
    ProcessPaymentType.ExternalPayment,
    ProcessPaymentType.PaymentRequest,
];
